import * as React from 'react'
import { Link } from 'gatsby'

import * as styles from 'src/components/atoms/common/Button/style.module.styl'

interface IProps {
  className?: string
  tgt?: '_blank' | '_self'
  handleClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>, options: any) => void
  url?: string
  value?: string
  name?: string
  isEntered?: boolean
  children?: React.ReactNode
  options?: any
}

const Component:React.FC<IProps> = (props) => {
  const name = props.name && (
    <span dangerouslySetInnerHTML={{ __html: props.name }} />
  )

  return (
    <div className={`${styles.btn_wrap} ${props.className && styles[props.className]}`}>
      {(!props.tgt || props.tgt === '_self') && props.url
        ? (
            // ページ遷移
            <Link to={props.url}>
              {name}
              {props.children}
            </Link>
          )
        : (props.tgt === '_blank'
            ? (
                // 外部リンク
                <a
                  href={props.url}
                  target={props.tgt}
                  onClick={(e) => { props.handleClick && props.handleClick(e, props.options) }}
                  rel="noreferrer noopener"
                >
                  {name}
                  {props.children}
                </a>
              )
            : (
                // callback
                <button
                  onClick={(e) => { props.handleClick && props.handleClick(e, props.options) }}
                  value={props.value}
                  disabled={props.isEntered}
                >
                  {name}
                  {props.children}
                </button>
              )
          )
      }
    </div>
  )
}

export default Component
